import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div(
  ({ theme: { colors, spacers } }) => css`
    background-color: ${colors!.colorWhite};
    border-radius: ${spacers!.spacer02};
    box-shadow: 0 0 4px -1px rgb(23 29 35 / 25%);
    width: 330px;
    height: 310px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: ${spacers!.spacer04};
  `
);

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const StyledWrapperTitle = styled.div(
  ({ theme: { colors, spacers } }) => css`
    display: flex;
    width: 100%;
    justify-content: space-between;
  `
);

export const StyledTitle = styled.div`
  font-family: InspireTWDC;
  font-size: 18px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0;
  text-align: left;
`;

export const StyledEmptyView = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  font-family: InspireTWDC;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0;
  text-align: center;
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg1[0]};
`;

export const StyledLoaderWrap = styled.div`
  max-width: 300px;
  width: 300px;
`;
